import React, { useEffect } from 'react';
import FooterCopyright from '@/components/FooterCopyright';
import Logo from '@/assets/logo@zzb.svg';
import LoginForm from './form';
import Banner from '@/components/Banner';
import styles from './style/index.module.less';
function Login() {
  useEffect(() => {
    document.body.setAttribute('arco-theme', 'light');
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.logo
  }, /*#__PURE__*/React.createElement(Logo, null), /*#__PURE__*/React.createElement("div", {
    className: styles['logo-text']
  }, "\u667A\u80FD\u88C5\u5907\u884C\u4E1A\u4F9B\u5E94\u94FE\u7BA1\u7406\u7CFB\u7EDF")), /*#__PURE__*/React.createElement("div", {
    className: styles.banner
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['banner-inner']
  }, /*#__PURE__*/React.createElement(Banner, null))), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['content-inner']
  }, /*#__PURE__*/React.createElement(LoginForm, null)), /*#__PURE__*/React.createElement("div", {
    className: styles.footer
  }, /*#__PURE__*/React.createElement(FooterCopyright, null))));
}
Login.displayName = 'LoginPage';
export default Login;